import React from 'react';
import * as Constants from 'mpm-config/Constants';
import Routes from './Routes';
class Utilities {
    getCurrentMenuActive() {
        let link = window.location.href;
        let found = undefined;
        Routes.forEach((element) => {
            if (!element.hidden && link.indexOf(element.path.toLowerCase()) !== -1) {
                found = element.key;
            }
        });
        return found;
    }
    getCurrentMenuItemActive() {
        let link = window.location.href;
        let found = undefined;
        Routes.forEach((eee) => {
            eee.children &&
                eee.children.forEach((element) => {
                    if (link.indexOf(element.path.toLowerCase()) !== -1) {
                        found = element.key;
                    }
                });
        });
        return found;
    }

    getTypeSourceDropDown = (autorized = []) => {
        let list = [];
        if (autorized.indexOf('1') !== -1) {
            list.push({ key: 1, value: '1', text: 'DC' });
        }
        if (autorized.indexOf('2') !== -1) {
            list.push({ key: 2, value: '2', text: 'ETA' });
        }
        if (autorized.indexOf('3') !== -1) {
            list.push({ key: 3, value: '3', text: 'CC' });
        }

        return list;
    };

    getTypeSourceName = (elem) => {
        switch (elem) {
            case '1':
                return <>Déclaration</>;
            case '2':
                return <>ETA</>;
            case '3':
                return <>Cession Capture</>;
            case '4':
                return <>Cession Produit</>;
            default:
                return <></>;
        }
    };

    getCPTypeSourceDropDownOptions = () => {
        return [
            { key: 3, value: '3', text: 'CC' },
            { key: 4, value: '4', text: 'CP' },
        ];
    };

    isAutorizedUser = (user, pageRoles = [], currentPath) => {
        // Always authorize access to /profile/settings regardless of the user's roles
        if (currentPath === '/profile/settings') {
            return true;
        }

        // Existing role-based authorization logic
        let authorized = false;
        pageRoles.forEach((role) => {
            if (user.role.indexOf(role) !== -1) {
                authorized = true;
            }
        });
        return authorized;
    };

    isNotEmpty = (element) => {
        return element !== '' && element !== [] && element !== null && element.length > 0;
    };

    getTypeSourceValueByRole = (role) => {
        if (role.indexOf(Constants.ROLE_MAREYEUR) !== -1) {
            return ['2', '3'];
        }
        if (role.indexOf(Constants.ROLE_ARMATEUR) !== -1) {
            return ['1', '3'];
        }
        if (role.indexOf(Constants.ROLE_USINIER) !== -1) {
            return [];
        }
        if (role.indexOf(Constants.ROLE_EXPORTATEUR) !== -1) {
            return [];
        }
        if (role.indexOf(Constants.ROLE_ADMIN) !== -1) {
            return ['1', '2', '3'];
        }
        return [];
    };

    getTypeAcquereurCCDropDownOptions = (connectedUser = null) => {
        let roles = connectedUser && connectedUser.role;
        if (!connectedUser || roles.indexOf(Constants.ROLE_ADMIN) !== -1) {
            return [
                { key: 1, text: 'Mareyeur', value: Constants.CODE_ACQU_MARAYEUR },
                { key: 2, text: 'Armateur', value: Constants.CODE_ACQU_ARMATEUR },
                { key: 3, text: 'Usinier', value: Constants.CODE_ACQU_USINIER },
                { key: 4, text: 'Exportateur', value: Constants.CODE_ACQU_EXPORTATEUR },
            ];
        }
        if (roles.indexOf(Constants.ROLE_MAREYEUR) !== -1) {
            return [
                { key: 1, text: 'Mareyeur', value: Constants.CODE_ACQU_MARAYEUR },
                { key: 3, text: 'Usinier', value: Constants.CODE_ACQU_USINIER },
                { key: 4, text: 'Exportateur', value: Constants.CODE_ACQU_EXPORTATEUR },
            ];
        }

        if (roles.indexOf(Constants.ROLE_ARMATEUR) !== -1) {
            return [
                { key: 2, text: 'Armateur', value: Constants.CODE_ACQU_ARMATEUR },
                { key: 3, text: 'Usinier', value: Constants.CODE_ACQU_USINIER },
                { key: 4, text: 'Exportateur', value: Constants.CODE_ACQU_EXPORTATEUR },
            ];
        }
    };
    getTypeAcquereurCPDropDownOptions = (entreposage = false) => {
        if (entreposage) {
            return [{ key: 3, text: 'Usinier', value: Constants.CODE_ACQU_USINIER }];
        } else {
            return [
                { key: 3, text: 'Usinier', value: Constants.CODE_ACQU_USINIER },
                { key: 4, text: 'Exportateur', value: Constants.CODE_ACQU_EXPORTATEUR },
            ];
        }
    };

    getTypeCedantDropDownOptions = () => {
        return [
            { key: 1, text: 'Mareyeur', value: Constants.CODE_ACQU_MARAYEUR },
            { key: 2, text: 'Armateur', value: Constants.CODE_ACQU_ARMATEUR },
        ];
    };

    getCessionCaptureAcquereurEtatsDropDownOptions = () => {
        return [
            { key: 0, text: 'En cours de validation', value: Constants.CC_ETAT_ENCOURS_VALIDATION },
            { key: 1, text: 'Validée(En cours de confirmation)', value: Constants.CC_ETAT_VALIDER },
            { key: 3, text: "Confirmée par l'acquereur", value: Constants.CC_ETAT_CONFIRMER },
            {
                key: 7,
                text: 'En attente de confirmation annulation',
                value: Constants.CC_ETAT_EN_ATTETE_CONFIRMATION_ANNULATION,
            },
        ];
    };

    getDeclarationventeEtatsDropDownOptions = () => {
        return [
            { key: 0, text: 'Enregistrée', value: Constants.CC_ETAT_ENCOURS_VALIDATION },
            { key: 1, text: 'Validée', value: Constants.CC_ETAT_VALIDER },
        ];
    };
    getCessionExportEtatsDropDownOptions = () => {
        return [
            { key: 0, text: 'En cours de validation', value: Constants.CC_ETAT_ENCOURS_VALIDATION },
            { key: 1, text: 'Validée(En cours de confirmation)', value: Constants.CC_ETAT_VALIDER },
            { key: 3, text: "Confirmée par l'administration", value: Constants.CC_ETAT_CONFIRMER },
        ];
    };

    getCessionCaptureEtatLabel = (etat) => {
        switch (etat) {
            case '0':
                return 'En cours de validation';
            case '1':
                return 'Validée(En cours de confirmation)';
            case '3':
                return "Confirmée par l'acquereur";
            case '7':
                return 'En attente de confirmation annulation';
            default:
                return 'Introuvable';
        }
    };
    getCessionExportEtatLabel = (etat) => {
        switch (etat) {
            case '0':
                return 'En cours de validation';
            case '1':
                return 'Validée(En cours de confirmation)';
            case '3':
                return "Confirmée par l'administration";
            default:
                return 'Introuvable';
        }
    };
    getDeclarationVenteEtatLabel = (etat) => {
        switch (etat) {
            case '0':
                return 'Enregistrée';
            case '1':
                return 'Validée ';
            default:
                return 'Introuvable';
        }
    };

    getCessionCaptureCedantEtatsDropDownOptions = () => {
        return [
            { key: 1, text: 'Validée', value: Constants.CC_ETAT_VALIDER },
            { key: 3, text: 'Confirmée', value: Constants.CC_ETAT_CONFIRMER },
            { key: 7, text: "Confirmation d'annulation", value: Constants.CC_ETAT_EN_ATTETE_CONFIRMATION_ANNULATION },
        ];
    };

    isCedantAutorized = (etat) => {
        return etat !== Constants.CC_ETAT_VALIDER &&
            etat !== Constants.CC_ETAT_CONFIRMER &&
            etat !== Constants.CC_ETAT_EN_ATTETE_CONFIRMATION_ANNULATION
            ? true
            : false;
    };

    getBreadCrumbData = (data = [], showForm, showView, showList) => {
        showForm && data.push(showForm);
        showList && data.push(showList);
        showView && data.push(showView);
        return data;
    };

    isNotNull = (param) => {
        return typeof param !== 'undefined' && param && param !== '' && param !== null;
    };

    getCPTypeTransformationDropDownOption = () => {
        return [
            { key: 1, text: 'Conserve', value: Constants.CP_TYPETRANS_CONSERVE },
            { key: 2, text: 'Congele', value: Constants.CP_TYPETRANS_CONGELE },
        ];
    };

    b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize),
                byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    };

    openBase64InNewTab = (data = null, type, reference) => {
        var a = document.createElement('a'); //Create <a>
        a.href = `${data}`; //Image Base64 Goes here
        a.download = reference + '.pdf'; //File name Here
        a.click();
    };

    getCCStatistics = (data) => {
        return [
            {
                key: 0,
                label: this.getCessionCaptureEtatLabel('0'),
                value: data.countCC0 ? data.countCC0 : '-',
                color: '#0068af',
            },
            {
                key: 1,
                label: this.getCessionCaptureEtatLabel('1'),
                value: data.countCC1 ? data.countCC1 : '-',
                color: '#2f94d9',
            },
            {
                key: 3,
                label: this.getCessionCaptureEtatLabel('3'),
                value: data.countCC3 ? data.countCC3 : '-',
                color: '#00c3ff',
            },
            {
                key: 7,
                label: this.getCessionCaptureEtatLabel('7'),
                value: data.countCC7 ? data.countCC7 : '-',
                color: '#00c3ff',
            },
        ];
    };
    getCPStatistics = (data) => {
        return [
            {
                key: 0,
                label: this.getCessionCaptureEtatLabel('0'),
                value: data.countCP0 ? data.countCP0 : '-',
                color: '#0068af',
            },
            {
                key: 1,
                label: this.getCessionCaptureEtatLabel('1'),
                value: data.countCP1 ? data.countCP1 : '-',
                color: '#2f94d9',
            },
            {
                key: 3,
                label: this.getCessionCaptureEtatLabel('3'),
                value: data.countCP3 ? data.countCP3 : '-',
                color: '#00c3ff',
            },
            {
                key: 7,
                label: this.getCessionCaptureEtatLabel('7'),
                value: data.countCP7 ? data.countCP7 : '-',
                color: '#00c3ff',
            },
        ];
    };
    getEXPStatistics = (data) => {
        return [
            {
                key: 0,
                label: this.getCessionCaptureEtatLabel('0'),
                value: data.countEXP0 ? data.countEXP0 : '-',
                color: '#0068af',
            },
            {
                key: 1,
                label: this.getCessionCaptureEtatLabel('1'),
                value: data.countEXP1 ? data.countEXP1 : '-',
                color: '#2f94d9',
            },
            {
                key: 3,
                label: this.getCessionCaptureEtatLabel('3'),
                value: data.countEXP3 ? data.countEXP3 : '-',
                color: '#00c3ff',
            },
        ];
    };

    getCPEspecesDropDownOptions(allEspeces = []) {
        let data = [];
        allEspeces.forEach((espece) => {
            const refEspece = espece.refEspece;
            if (!data.find((esp) => esp.key === refEspece.id)) {
                data.push({ key: refEspece.id, value: refEspece, text: refEspece.libelle });
            }
        });
        return data;
    }

    getCPTransformationDropDownOptions(allEspeces = []) {
        let data = [];

        allEspeces.forEach((espece) => {
            const refTransf = espece.refTypeTransf;
            if (!data.find((esp) => esp.key === refTransf.id)) {
                data.push({ key: refTransf.id, value: refTransf, text: refTransf.nom });
            }
        });
        return data;
    }

    isUsinier = (user) => {
        return user && user.role && user.role.find((elem) => elem === Constants.ROLE_USINIER);
    };

    isExportateur = (user) => {
        return user && user.role && user.role.find((elem) => elem === Constants.ROLE_EXPORTATEUR);
    };

    isNumber = (string) => {
        var reg = /^[0-9]+(\.[0-9]+)?$/;
        return reg.test(string);
    };

    cleanNumber = (data) => {
        return this.isNumber(data) ? data : isNaN(Number(data)) ? 0 : Number(data);
    };

    round(value, numberDecimal = 3) {
        return parseFloat(value).toFixed(numberDecimal);
    }
}

export default new Utilities();
